module.exports = __webpack_public_path__ + "static/media/style2-2.cc0616a2.gif";